import { styled } from '../muiReexports';
import { MenuItem } from './MenuItem';
export const MenuItemStyled = styled(MenuItem)(({ theme }) => ({
    '& > em': {
        color: theme.palette.text.muted,
    },
}));
